<template>
  <v-dialog
    :value="value"
    :width="$vuetify.breakpoint.smAndDown ? '100%' : '500'"
    persistent
  >
    <v-card class="pa-5" style="border-radius: 12px">
   
      <Signin
        :error="errorMessage"
        @onLogin="login"
        @checkoutAsGuest="checkoutAsGuest"
        @onSignupSuccess="register"
        @setPassword="setPassword"
        @setFirstname="setFirstname"
        @setLastname="setLastname"
        @setEmail="setEmail"
        :only-facebook-login="false"
        :signupDetail="form"
      ></Signin>
    </v-card>
  </v-dialog>
</template>

<script>
import Signin from './Signin'
import Service from '../services'
import { mapState } from 'vuex'
export default {
  name: 'LoginDialog',
  data() {
    return {
      form: {
        email: '',
        password: '',
        firstname: '',
        lastname: ''
      },
      errorMessage: null
    }
  },
  computed: {
    ...mapState({
      profile: (state) => state.Auth.userDetail,
      tempProfile: (state) => state.Auth.tempUserDetail,
      accessToken: (state) => state.Auth.userDetail.access_token
    })
  },
  components: {
    Signin
  },
  props: {
    value: {
      default: false
    }
  },
  methods: {
    setPassword(data) {
      this.form.password = data
    },
    setFirstname(data) {
      this.form.firstname = data
    },
    setLastname(data) {
      this.form.lastname = data
    },
    setEmail(data) {
      this.form.email = data
    },
    async checkoutAsGuest() {
      if (this.tempProfile.access_token) {
        this.$store.commit('Auth/setUserDetail', this.tempProfile)
      } else {
        await this.$store.dispatch('Auth/logInAsGuest', this.$uuid.v4())
        let data = {
          email: this.profile.email,
          firstname: this.profile.firstname,
          lastname: this.profile.lastname,
          is_guest: true
        }
        await this.register(data, true)
      }
      await this.eventClose()
    },
    login(data) {
      data.is_admin = true;
      this.$store.dispatch("Loading/onSetLoading",true);
      Service.auth.login(data).then((res) => {
        if (res.status == 200) {
          this.$store.commit('Auth/setUserDetail', res.data)
          this.errorMessage = ''
          this.$store.dispatch("Loading/onSetLoading",false);
          this.$router.push({ name: 'main-layout' });
        } else if (res.status == 401) {
          this.$store.dispatch("Loading/onSetLoading",false);
          this.errorMessage = res.data.message
        }
      })
    },
    async register(data, isGuest = false) {
      this.$store.dispatch("Loading/onSetLoading",true);
      await Service.auth.register(data).then((res) => {
        if (res.status == 200) {
          if (isGuest) {
            this.$store.commit('Auth/setTempUserDetail', res.data)
          }
          this.$store.commit('Auth/setUserDetail', res.data)
          this.errorMessage = ''
          this.$store.dispatch("Loading/onSetLoading",false);
          this.eventClose()
        } else if (res.status == 401) {
          this.errorMessage = 'Invalid username or password'
          this.errorMessage = res.data.message
        }
      })
    },
    eventClose() {
      this.$store.commit('Auth/loginDialogHandle', false)
    }
  }
}
</script>

<style scoped>
</style>
